import isString from 'lodash/isString';
import { useEffect, useState } from 'react';

import { from } from 'rxjs';
import { isBase64 } from '@Utils/Network/Network';
import RxThumbnail from '@Services/RxThumbnail';

const molImgReg = /\/molimg/;

export default function useStructureSrc(structure) {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (isBase64(structure)) {
      setSrc(structure);

      return;
    }

    if (isString(structure) && molImgReg.test(structure)) {
      setSrc(structure);

      return;
    }

    if (!structure) {
      setSrc('');
      return;
    }

    const subscription = from(RxThumbnail.memoGetModalThumbnail(structure)).subscribe((data) => {
      setSrc(data.url);
    });

    // eslint-disable-next-line consistent-return
    return () => {
      setSrc('');
      subscription.unsubscribe();
    };
  }, [structure]);

  return src;
}
